"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHAINLINK_CONTRACT = exports.DEFAULT_REVERSE_RESOLVER_CONTRACT = exports.REVERSE_REGISTRAR_CONTRACT = exports.BULK_RENEWAL_CONTRACT = exports.REGISTRAR_CONTROLLER_CONTRACT = exports.REGISTRAR_CONTRACT = exports.RESOLVER_CONTRACT = exports.BNS_REGISTRY_CONTRACT = void 0;
// goerli:
// bnsRegistry
var BNS_REGISTRY_CONTRACT = '0x799f64EC92E82cc1eC504B53DD79b3E2ea92396b'; // publicResolver

exports.BNS_REGISTRY_CONTRACT = BNS_REGISTRY_CONTRACT;
var RESOLVER_CONTRACT = '0xBBB50544ABb041ec04B1B0dE68EaC6Aad3787e56'; // baseRegistrarImpl

exports.RESOLVER_CONTRACT = RESOLVER_CONTRACT;
var REGISTRAR_CONTRACT = '0x457eFd33Def0bFF2dfe33089D385898D919d3a10'; // registrarController

exports.REGISTRAR_CONTRACT = REGISTRAR_CONTRACT;
var REGISTRAR_CONTROLLER_CONTRACT = '0x7d311cCb3b4F5006A1215418BfC45961fC5609e4'; // BulkRenewal

exports.REGISTRAR_CONTROLLER_CONTRACT = REGISTRAR_CONTROLLER_CONTRACT;
var BULK_RENEWAL_CONTRACT = '0xF50cEF4cd848b010dA163A480Fb962b0f0c2576f'; // reverseRegistrar

exports.BULK_RENEWAL_CONTRACT = BULK_RENEWAL_CONTRACT;
var REVERSE_REGISTRAR_CONTRACT = '0xDC9210e1aD4e08DB40bdbE3d9A55155Bfde82c70'; // defaultReverseResolver

exports.REVERSE_REGISTRAR_CONTRACT = REVERSE_REGISTRAR_CONTRACT;
var DEFAULT_REVERSE_RESOLVER_CONTRACT = '0x3CeDeBb16852f94fBA58AE0c4cc6AfB337C8082c'; // chainlink contract address

exports.DEFAULT_REVERSE_RESOLVER_CONTRACT = DEFAULT_REVERSE_RESOLVER_CONTRACT;
var CHAINLINK_CONTRACT = '0xD4a33860578De61DBAbDc8BFdb98FD742fA7028e';
exports.CHAINLINK_CONTRACT = CHAINLINK_CONTRACT;